// extracted by mini-css-extract-plugin
export var body = "_o1-8";
export var button = "_o1-0";
export var closeButton = "_o1-5";
export var content = "_o1-3";
export var empty = "_o1-f";
export var grid = "_o1-c";
export var header = "_o1-4";
export var icon = "_o1-1";
export var option = "_o1-d";
export var optionSelected = "_o1-e";
export var overlay = "_o1-2";
export var searchIcon = "_o1-a";
export var searchInput = "_o1-b";
export var searchWrapper = "_o1-9";
export var title = "_o1-6";
export var visuallyHidden = "_o1-7";